import { device } from 'constants/device';

import styled from 'styled-components';

export const ShowAllText = styled.a`
  font-weight: bold;
  font-size: 2rem;
  line-height: 1.2;
  text-align: right;
  color: ${({ theme }) => theme.system.darkGreyActive};
  display: inline-flex;
  align-items: flex-end;
  @media ${device.tablet} {
    font-size: 1.4rem;
    line-height: 1.7rem;
  }
`;
